import type { FaireProductEntity } from "../../entity_types/product";

export const p_gtc286czzw: FaireProductEntity = {
  token: "p_gtc286czzw",
  type: "product",
  name: "Women's Fuzzy Crew Socks with Non-Slip Grippers",
  brandToken: "b_br6ji29u",
  brandName: "Softies",
  imageUrl: "https://cdn.faire.com/fastly/4093f568deaf074b7a20b14851fbafd6306bbf9579218f5d594c382d9135e903.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/41807541cc6c7fa6ffe0fc64d1074a45f4abfaf8ee33ef0c645db343a546f6fe.png",
    "https://cdn.faire.com/fastly/147ee29ad1d154e4c1ac1ad996469aea24cfd39520f20263bd75fc0005407f63.png",
    "https://cdn.faire.com/fastly/9a259a0b52f45ac949c294df4d49e00c6c11396491ee014bead6a9209de13431.png",
    "https://cdn.faire.com/fastly/91cd6b9151a5406963923f029725e8b5f8cbf1e65521146604109fec513a4779.png",
    "https://cdn.faire.com/fastly/ae3cf192afce00bbba89277a9ebaf6dec861df3aa13865552f2ba9eb540d4867.png",
    "https://cdn.faire.com/fastly/8db7e4eab63cceb73fb9c78350e6bcff18e414d64771915ca1debc8bb940223b.png",
    "https://cdn.faire.com/fastly/ff9f86f30476cc28b0db07874d3397b7255ae5f8fc6be8d16502ab9eabe7688c.png",
    "https://cdn.faire.com/fastly/718ccfe0ea5449d9792d9adc4c1d4fbc5c50698f87645d61be0a13207d46dda2.png",
    "https://cdn.faire.com/fastly/65cd409f870233770b25aac96eaca50f6ee46f9f3028fe672c496fee05b50eca.png",
    "https://cdn.faire.com/fastly/d1e21d6277406da92f22f630ba39e0643fad1a0501901d1cda90909546f3973a.png",
    "https://cdn.faire.com/fastly/7a3ba46f2b48f9f08699cc87dc13727364ba5a8d7df1db7bd5b89a84374f7bbb.png",
    "https://cdn.faire.com/fastly/8a41fad0b9e982331d805dbfdcafd9f4df854d607e78da8684347a7650756165.jpeg",
    "https://cdn.faire.com/fastly/7007b1ec0e409fb6e3622f3f3bcb7c067b2a89c367b37b8dbb55bff5035bcd71.jpeg",
    "https://cdn.faire.com/fastly/1039fa719b10e82314d7a3526ae3030c505b292df8eaab49f3af925ddd8d9c33.jpeg",
    "https://cdn.faire.com/fastly/87bf01b0805efd039c6a42935937ca633d0eb8a2b54cffbb15f7a5f0c6b61661.jpeg",
    "https://cdn.faire.com/fastly/1b112eca87b9eee25ca38fb06589124852b7119ec7daf2b5c90d08964fd51552.jpeg",
    "https://cdn.faire.com/fastly/af59423d218c1dc7dfe668ee6bf92822b9bff7b69570e1901f7d73b351594155.jpeg",
    "https://cdn.faire.com/fastly/cce6b21462216cd19a7a3d125cfcfec8f0501dded56a62fffef643c425ca1d91.jpeg",
    "https://cdn.faire.com/fastly/59a74c34f2d365e9e5fac06cc8f4f8ec9dc8ad160d2be43849a0947017d0ec44.jpeg"
  ],
  priceDollars: 12,
  description: "Step into comfort with our Marshmallow Crew Socks. Echoing the beloved design of our longer-length socks, the delicate ribbing feels like a cozy hug for your feet. They feature no-slip grip bottoms for easy walking on hardwood floors or pacing a hospital room.\n\nOur signature Marshmallow fabric makes them decadently soft, making it the perfect gift for just about anyone–especially expectant mothers. Kick up your feet in a pair of socks you’ll never want to take off.\n\n𝐅𝐞𝐚𝐭𝐮𝐫𝐞𝐬\n• Crew length\n• Non-slip grippers\n• Heather marshmallow fabric",
  tags: [],
  msrpDollars: 24,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-09-02T03:46:58.682Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
